import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Core } from '../../../../../../helpers';
import Grid from '@material-ui/core/Grid';
import Select from '../../../../../../components/Select.component';
import Paper from '../../../../../../components/Paper.component';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Avatar from '@material-ui/core/Avatar';
import AddIcon from '@material-ui/icons/Add';
import Collapse from '@material-ui/core/Collapse';
import TextField from '../../../../../../components/Textfield.component';

const styles = theme => ({
    training: {
        padding: theme.spacing(3),
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: theme.palette.grey[200],
        borderRightWidth: 1,
        borderRightStyle: 'solid',
        borderRightColor: theme.palette.grey[200],
        '&:nth-child(3n + 3)': {
            borderRight: 'none',
        }
    },
    lastRow: {
        borderBottom: 'none',
    },
    image: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 210,
        marginBottom: theme.spacing(2),
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center, center',
    },
    error: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderBottomColor: theme.palette.grey[200],
    },
    hidden: {
        display: 'none',
    },
    firstselect: {
        marginBottom: theme.spacing(2),
    }
})

class CustomizeTrainingsCustomUrl extends React.Component {

    static mapStateToProps(state, props) {
        const { campaign } = state;
        return {
            ...props,
            trainings: campaign.current.data.trainings,
            campaignLanguage: Core.campaignLanguage(campaign.current.data.language, 'course'),
        };
    }

    constructor(props) {
        super(props);

        const trainingsArray = Object.keys(props.trainings).filter(key => {
            return props.trainings[key].Language === props.campaignLanguage || props.trainings[key].Language === '';
        });
        const fieldLength = Core.getTrainingsFieldLength(trainingsArray.length, props.field.max, props.field.min);

        this.state = {
            fieldLength: fieldLength,
            selected: Array.isArray(props.value) ? props.value : Array(fieldLength).fill("-1"),
            lastRowFilled: Math.floor(fieldLength / 3) * 3,
            trainingsArray: trainingsArray,
            firstrun: !Array.isArray(props.value)
        }
    }

    UNSAFE_componentWillMount() {
        const {
            trainings,
            campaignLanguage,
            prodKey,
            field,
            onHandleChangeField,
        } = this.props;
        const {
            selected,
            firstrun,
            fieldLength,
            trainingsArray,
        } = this.state;

        // Prefill training slots
        const path = prodKey + '.' + field.field;
        let nextPick = 0;
        const unusedTrainingsArray = trainingsArray.filter(item => selected.indexOf(item) < 0);

        // Selected Training not found or in wrong language, replace with next available training.
        selected.forEach((t, i) => {
            const v = this.getId(t);
            if (!trainings[v] || (trainings[v].Language !== campaignLanguage && trainings[v].Language !== '')) {
                if (i < fieldLength) {
                    if (firstrun || !field.deselectedallowed) {
                        if (unusedTrainingsArray.length > 0) {
                            selected[i] = unusedTrainingsArray[nextPick];
                            nextPick++
                            nextPick = nextPick > (unusedTrainingsArray.length - 1) ? 0 : nextPick;
                        }
                        else {
                            selected[i] = trainingsArray[nextPick];
                            nextPick++
                            nextPick = nextPick > (trainingsArray.length - 1) ? 0 : nextPick;
                        }
                    }
                    else {
                        selected[i] = "-1"
                    }
                }
                else {
                    selected[i] = "-1"
                }
            }
        })

        // A training has been added. Extend selected.
        if (selected.length < fieldLength) {
            while (selected.length < fieldLength) {
                const newArray = trainingsArray.filter(el => {
                    return !selected.includes(el);
                })
                selected.push(newArray[0])
            }
        }

        // A training has been removed. 
        if (selected.length > fieldLength) {
            selected.length = fieldLength;
        }

        // Put empty selections at the back.
        selected.sort((a, b) => {
            if (a === '-1') {
                return 1;
            }
            else if (b === '-1') {
                return -1;
            }
            else return 0;
        })

        this.setState({
            selected: selected,
        });
        onHandleChangeField(path, selected);

        // Preload training images.
        trainingsArray.forEach((key, i) => {
            const img = new Image();
            img.src = (() => {
                if (trainings[key].AssetList.length) {
                    return trainings[key].AssetList.find((asset) => {
                        return asset.CategoryId === 301
                    })?.Value;
                }

                return trainings[key].TileTransparent;
            })();
        })
    }

    handleSelect = (e) => {
        const {
            selected
        } = this.state;
        const {
            prodKey,
            field,
            onHandleChangeField
        } = this.props;
        const pos = parseInt(e.target.name);
        const value = e.target.value;
        const path = prodKey + '.' + field.field;

        selected[pos] = value;
        this.setState({ selected: selected });
        onHandleChangeField(path, selected);
    }

    handleCustomUrl = (e) => {
        const {
            selected
        } = this.state;
        const {
            prodKey,
            field,
            onHandleChangeField
        } = this.props;
        const pos = parseInt(e.target.name.split('-')[1]);
        const value = e.target.value;
        const path = prodKey + '.' + field.field;
        if (value.length > 0) {
            selected[pos] = `${this.getId(selected[pos])}|${value}`;
        }
        else {
            selected[pos] = `${this.getId(selected[pos])}`;
        }
        this.setState({ selected: selected });
        onHandleChangeField(path, selected);
    }

    getId = (value) => {
        return value.split('|')[0];
    }

    getUrl = (value) => {
        return value.split('|')[1];
    }

    getLowResImage = (training) => {
        const imgHiRes = training.AssetList.find((asset) => {
            return asset.CategoryId === 301
        })?.Value;
        const imgLowRes = training.CourseTileTransparent.slice(-3) === 'png' ? training.CourseTileTransparent : imgHiRes;
        return imgLowRes;
    }

    getImage = (value) => {
        const { trainings } = this.props;
        const id = this.getId(value);
        if (id && trainings[id]) {
            return `${this.getLowResImage(trainings[id])}`
        }
        return 'none';
    }

    getBackgroundImage = (value) => {
        const { trainings } = this.props;
        const id = this.getId(value);
        if (id && trainings[id]) {
            return `url(${this.getLowResImage(trainings[id])})`
        }
        return 'none';
    }

    getBackgroundColor = (value) => {
        const { trainings } = this.props;
        const id = this.getId(value);
        if (id > 0 && trainings[id]) {
            return trainings[id].CourseCategoryColor
        }
        return '#FFFFFF';
    }

    render() {
        const {
            classes,
            field,
            trainings,
            error,
            errorText,
            hidden,
        } = this.props;
        const {
            selected,
            fieldLength,
            trainingsArray,
            lastRowFilled,
        } = this.state;
        // console.log('EH state', this.state);
        // console.log('EH props', this.props);

        return (
            <React.Fragment>
                <Grid
                    container
                    className={classNames({ [classes.hidden]: hidden })}
                >
                    <Grid
                        item
                        xs={12}
                    >
                        <Collapse in={error}>
                            <Typography
                                color="error"
                                variant="caption"
                                className={classes.error}
                            >
                                {errorText}
                            </Typography>
                        </Collapse>
                    </Grid>
                </Grid>
                <Grid
                    container
                    className={classNames({ [classes.hidden]: hidden })}
                >
                    {[...Array(fieldLength)].map((e, i) =>
                        <Grid
                            item xs={12}
                            key={i}
                            className={classNames(
                                classes.training,
                                {
                                    [classes.lastRow]: i + 1 > lastRowFilled,
                                }
                            )}
                        >
                            <Grid container>
                                <Grid item xs={12} className={classes.firstselect}>
                                    <Select
                                        name={String(i)}
                                        value={this.getId(selected[i])}
                                        displayEmpty
                                        onChange={this.handleSelect}
                                        style={{ padding: 0 }}
                                        renderValue={key => {
                                            return (
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div
                                                        style={{
                                                            backgroundColor: this.getBackgroundColor(selected[i]),
                                                            width: 50,
                                                            height: 50,
                                                            borderRadius: 4,
                                                            marginRight: 26
                                                        }}
                                                    >
                                                        {trainings[key] &&
                                                            <img
                                                                src={this.getImage(selected[i])}
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%'
                                                                }}
                                                            />
                                                        }
                                                    </div>
                                                    {trainings[key] ? trainings[key].CourseTitle : '...'}
                                                </div>
                                            )
                                        }}
                                    >
                                        {field.deselectedallowed &&
                                            <MenuItem value="-1">...</MenuItem>
                                        }
                                        {trainingsArray.map((key) =>
                                            <MenuItem key={key} value={key}>{trainings[key].CourseTitle}</MenuItem>
                                        )}
                                    </Select>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        name={`customUrl-${i}`}
                                        onChange={this.handleCustomUrl}
                                        value={selected[i].split('|')[1]}
                                        placeholder="https://"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </React.Fragment>
        )
    }
}

export default withStyles(styles)(
    connect(CustomizeTrainingsCustomUrl.mapStateToProps, {})(CustomizeTrainingsCustomUrl)
);
